export enum LoadingState {
    Idle = "Idle",
    InitialLoad = "InitialLoad",
    Loading = "Loading",
}

export function getLoginPersistanceTimeout() {
    const hours: number = 1
    return hours
}